import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { supabaseClient } from "../utils/supabase";

export interface Profile {
    profile_id: string;
    phone: string;
    is_admin: boolean;
    created_at?: string;
    preferred_locale?: string | null;
}

export function useProfile(
    userId: string | null,
    options?: Omit<UseQueryOptions<Profile | null>, "queryKey" | "queryFn">
) {
    return useQuery({
        queryKey: ["profile", userId],
        queryFn: async (): Promise<Profile | null> => {
            if (!userId) return null;

            const { data, error } = await supabaseClient
                .from("profiles")
                .select("profile_id, phone, is_admin, created_at, preferred_locale")
                .eq("profile_id", userId)
                .maybeSingle();

            if (error) {
                console.error("Error fetching profile:", error);
                throw error;
            }

            return data;
        },
        enabled: !!userId,
        retry: (failureCount, error: any) => {
            // Don't retry if profile doesn't exist (PGRST116)
            if (error?.code === "PGRST116") {
                return false;
            }
            return failureCount < 3;
        },
        ...options,
    });
}
